// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__6GnaJ","fadeIn":"Modal_fadeIn__zuilp","modalContent":"Modal_modalContent__JODE3","slideUp":"Modal_slideUp__jsM5M"};